
import React, { useState } from 'react';
import { Modal, Button, Form, 
    // ProgressBar 
} from 'react-bootstrap';   // <-- added ProgressBar
import { formatDistanceToNow, format } from 'date-fns';
// import toast from "react-hot-toast";

import { fetchDraftCount, fetchDraftList, deleteDraft, renameDraft } from '../../../redux/feature/drafts/draftsSlice';


import { useNavigate } from 'react-router-dom';

import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';


export const DraftButton = ({ draftType, onClick, className }) => {

    const dispatch = useDispatch()

    // const [draftTotal, setDraftTotal] = useState(0);

    const count = useSelector((state) => state.drafts.count)

    let userData = useSelector((state) => state?.user);

    useEffect(() => {

        try {
            console.log('Fetching draft count for userId:', userData?.data?.userId);
            // const response = await ItemService.getDraftCount(userData?.data?.userId, draftType);
            // setDraftTotal(response.data.count);
            if (userData?.data?.userId) {
                dispatch(fetchDraftCount({ userId: userData.data.userId, draftType }));
            }
        } catch (error) {
            console.error('Error fetching draft count:', error);
        }

    }, [dispatch, userData?.data?.userId, draftType])

    return (<Button className={`btnTable ${className} text-nowrap` } onClick={onClick}  title={count > 0 ? `View Drafts (${count})` : "View Drafts"}>
        <i className="bi bi-file-earmark-text"></i> Drafts 
        {count > 0 && (
            // <sup style={{ fontSize: '0.8rem', color: 'red', fontWeight: 'bolder', marginLeft: '2.5px' }}>
              <b>  ({count}) </b>
            // </sup>
        )}
    </Button>
    )
};

const DraftSelectionModal = ({
    show,
    onHide,
    draftType,
    onSelectDraft,
    toNavigate,
    onDeleteDraft,
}) => {

    const [selectedDraftId, setSelectedDraftId] = useState(null);
    const [renamingDraftId, setRenamingDraftId] = useState(null);
    const [newName, setNewName] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate()

    let userData = useSelector((state) => state?.user);

    const draftsList = useSelector((state) => state.drafts.list);
    const loading = useSelector((state) => state.drafts.loading);

    const handleSelect = (draftNumber) => {
        setSelectedDraftId(draftNumber);
    };



    const handleRename = (draftNumber, currentName) => {
        setRenamingDraftId(draftNumber);
        setNewName(currentName);
    };

    const submitRename = () => {
        if (renamingDraftId && newName.trim()) {
            handleRenameDraft(renamingDraftId, newName.trim());
            setRenamingDraftId(null);
            setNewName('');
        }
    };

    const cancelRename = () => {
        setRenamingDraftId(null);
        setNewName('');
    };

    const getDisplayName = (draft) => {
        return draft.draftName || 'Draft';
    };

    const getLastUpdated = (draft) => {
        return draft.updatedAt
            ? formatDistanceToNow(new Date(draft.updatedAt), { addSuffix: true })
            : 'N/A';
    };

    const getCreated = (draft) => {
        return draft.createdAt
            ? format(new Date(draft.createdAt), 'MMM dd, yyyy HH:mm')
            : 'N/A';
    };


    useEffect(() => {
        if (userData?.data?.userId && show) {
            dispatch(fetchDraftList({ userId: userData.data.userId, draftType }));
        }
    }, [userData?.data?.userId, draftType, show, dispatch]);


    const handleRenameDraft = (documentNumber, newName) => {
        dispatch(renameDraft({
            documentNumber,
            userId: userData.data.userId,
            draftType,
            newName
        }));
        // Redux will update the draft name in the list instantly.
        setRenamingDraftId(null);
        setNewName('');
    };



    const handleContinue = () => {
        if (selectedDraftId) {
            onHide();
            navigate(toNavigate, { state: { draftId: selectedDraftId } });
        }
    };

    const handleNewDraft = () => {
        onHide();
        navigate(toNavigate, { state: { newDraft: true } });
    };

    const handleDeleteDraft = (documentNumber) => {
        if (window.confirm('Are you sure you want to delete this draft?')) {
            dispatch(deleteDraft({
                documentNumber,
                userId: userData.data.userId,
                draftType
            }));
            // Redux will automatically filter the list and decrement the count.
            // The modal UI will update instantly.
            if (selectedDraftId === documentNumber) setSelectedDraftId(null);
        }
    };



    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
            keyboard={false}
            className="draft-selection-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Saved Drafts</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-4">Loading drafts...</div>
                ) : draftsList.length === 0 ? (
                    <div className="text-center py-4">No saved drafts found. Start a new one.</div>
                ) : (
                    <div className="draft-list">
                        {draftsList.map((draft) => {
                            const isSelected = selectedDraftId === draft.documentNumber;
                            const isRenaming = renamingDraftId === draft.documentNumber;
                            const progress = draft.completionPercentage || 0;

                            return (
                                <div
                                    key={draft.documentNumber}
                                    className={`draft-item ${isSelected ? 'selected' : ''}`}
                                    onClick={() => handleSelect(draft.documentNumber)}
                                >
                                    <div className="draft-info">
                                        <div className="draft-name">
                                            {isRenaming ? (
                                                <Form.Control
                                                    type="text"
                                                    value={newName}
                                                    onChange={(e) => setNewName(e.target.value)}
                                                    onKeyDown={(e) => e.key === 'Enter' && submitRename()}
                                                    onClick={(e) => e.stopPropagation()}
                                                    autoFocus
                                                    size="sm"
                                                    className="rename-input"
                                                />
                                            ) : (
                                                <Form.Check
                                                    type="radio"
                                                    name="draftSelect"
                                                    id={`draft-${draft.documentNumber}`}
                                                    label={getDisplayName(draft)}
                                                    checked={isSelected}
                                                    onChange={() => handleSelect(draft.documentNumber)}
                                                    onClick={(e) => e.stopPropagation()}
                                                />
                                            )}
                                        </div>

                                        {/* 🆕 Progress Bar */}
                                        {/* <div className="draft-progress">
                                             <ProgressBar
                                                now={progress}
                                                label={`${progress}%`}
                                                variant={progress === 100 ? 'success' : 'primary'}
                                                style={{ height: '8px', fontSize: '0.65rem' }}
                                            /> 
                                            <span className="badge bg-info ms-2">{progress}%</span>
                                        </div> */}

                                        <div className="draft-meta">
                                            <span className="meta-item">
                                                <i className="bi bi-clock me-1"></i>
                                                {getLastUpdated(draft)}
                                            </span>
                                            <span className="meta-item">
                                                <i className="bi bi-calendar me-1"></i>
                                                {getCreated(draft)}
                                            </span>
                                            <span className="badge bg-info ms-2">{progress}%</span>
                                        </div>
                                    </div>
                                    <div className="draft-actions">
                                        {isRenaming ? (
                                            <>
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        submitRename();
                                                    }}
                                                    className="action-btn"
                                                >
                                                    <i className="bi bi-check-lg"></i>
                                                </Button>
                                                <Button
                                                    variant="secondary"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        cancelRename();
                                                    }}
                                                    className="action-btn"
                                                >
                                                    <i className="bi bi-x-lg"></i>
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                {/* <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onSelectDraft(draft.documentNumber);
                                                    }}
                                                    className="action-btn"
                                                    title="Open"
                                                >
                                                    <i className="bi bi-box-arrow-up-right"></i>
                                                </Button> */}

                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRename(draft.documentNumber, getDisplayName(draft));
                                                    }}
                                                    className="action-btn"
                                                    title="Rename"
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </Button>
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteDraft(draft.documentNumber);
                                                    }}
                                                    className="action-btn btn-danger"
                                                    title="Delete"
                                                >
                                                    <i className="bi bi-trash3"></i>
                                                </Button>
                                            </>
                                        )}

                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">

                <Button variant="secondary" onClick={onHide} className="btn-danger">
                    Cancel
                </Button>
                <div>
                    <Button
                        variant="primary"
                        onClick={handleContinue}
                        disabled={!selectedDraftId}
                    >
                        Continue Selected
                    </Button>
                    <Button
                        variant="outline-primary"

                        onClick={handleNewDraft}
                        className="ms-2 btn-success"
                    >
                        + Create New
                    </Button>
                </div>

            </Modal.Footer>

            {/* Custom styles - add .draft-progress */}
            <style jsx>{`
                .draft-selection-modal .draft-list {
          max-height: 400px;
          overflow-y: auto;
          padding: 0.25rem 0;
        }
        .draft-selection-modal .draft-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.75rem 1rem;
          margin-bottom: 0.5rem;
          border-radius: 0.5rem;
          border: 1px solid transparent;
          transition: all 0.2s ease;
          cursor: pointer;
          background-color: #f8f9fa;
        //   border: 2px solid red;
        }
        .draft-selection-modal .draft-item:hover {
          background-color: #e9ecef;
          border-color: #dee2e6;
        }
        .draft-selection-modal .draft-item.selected {
          background-color: #cfdef3;
        //   border-color: #0d6efd;
        //   box-shadow: 0 0 0 0.2px #0d6efd;
        }
        .draft-selection-modal .draft-info {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-width: 0;
        }
        .draft-selection-modal .draft-name {
          font-weight: 600;    /* bold */
          font-size: 1.1rem;   /* bigger */
          margin-bottom: 0.25rem;
        }
        .draft-selection-modal .draft-name .form-check-label {
          font-weight: inherit;
          font-size: inherit;
        }
        .draft-selection-modal .draft-name .rename-input {
          font-weight: 600;
          font-size: 1.1rem;
        }
        .draft-selection-modal .draft-meta {
          display: flex;
          gap: 1rem;
          font-size: 0.85rem;
          color: #6c757d;
        //   border: 2px solid green;
          padding-left: 1.5rem;
        }
        .draft-selection-modal .meta-item {
          display: flex;
          align-items: center;
        }
        .draft-selection-modal .draft-actions {
          display: flex;
          gap: 1rem;
          flex-shrink: 0;
          margin-left: 1rem;
        }
        .draft-selection-modal .action-btn {
          width: 32px;
          height: 32px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          color: white;
        }
        .draft-selection-modal .action-btn i {
          font-size: 1rem;
          line-height: 1;
          color: white;
        }
        // .draft-selection-modal .modal-footer {
        //   border-top: 1px solid #dee2e6;
        //   padding-top: 1rem;
        // }
          .draft-selection-modal .modal-footer {
      border-top: 1px solid #dee2e6;
          padding-top: 1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
          .draft-selection-modal .modal-footer div {

          min-width: 50%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
      }
        @media (max-width: 576px) {
          .draft-selection-modal .draft-item {
            flex-wrap: wrap;
          }
          .draft-selection-modal .draft-meta {
            flex-wrap: wrap;
            gap: 0.5rem;
          }
          .draft-selection-modal .draft-actions {
            margin-left: 0;
            margin-top: 0.5rem;
            width: 100%;
            justify-content: flex-end;
          }
        }


                .draft-selection-modal .draft-progress {
                    width: 100%;
                    max-width: 200px;
                    margin-top: 4px;
                    margin-bottom: 4px;
                    padding-left: 1.5rem; /* align with meta */
                }
                .draft-selection-modal .draft-progress .progress {
                    height: 8px;
                }
                .draft-selection-modal .draft-progress .progress-bar {
                    font-size: 0.65rem;
                    line-height: 8px;
                    color: #fff;
                    text-align: center;
                }

                @media (max-width: 576px) {
                    .draft-selection-modal .draft-progress {
                        max-width: 100%;
                        padding-left: 0;
                    }
                }
            `}</style>
        </Modal>
    );
};

export default DraftSelectionModal;